import {} from "./mutation-types.js";
export default {
  login: (state, data) => {
    state.userInfo = data;
    localStorage.setItem("userInfo", JSON.stringify(data));
    localStorage.setItem("hadLog", 1);
  },
  logout: state => {
    state.userInfo = null;
    localStorage.removeItem("userInfo");
    localStorage.removeItem("hadLog");
  },
  updateLoadingStatus(state, payload) {
    state.isLoading = payload.isLoading;
  },
  setData: (state, data) => {
    state.setData = JSON.parse(data);
  },
  setRequest: (state, data) => {
    state.isRequest = data;
  },
  clearData: state => {
    state.setData = {};
  },
  needsCheck: (state, data) => {
    state.needsCheck = data;
  },
  setChatAction: (state, data) => {
    state.showChatAction = data;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js